import React from 'react';
import SelectIcon from './SelectIcon';

import HexagonSVG from './HexagonSVG/HexagonSVG';

const Hexagon = props => (
  <React.Fragment>
    <HexagonSVG {...props} />
    <SelectIcon icon={props.icon} label={props.icon} />
    {props.children}
  </React.Fragment>
);

export default Hexagon;



// WEBPACK FOOTER //
// ./src/components/UI/Img/Hexagon.jsx